import { useEffect, useState, useRef } from "react";

import styles from "./Face3.module.scss";

export default function Face3() {
  const cardRef = useRef<HTMLDivElement>(null);

  const [fontSize, setFontSize] = useState<number | undefined>(undefined);
  const [letterSpacing, setLetterSpacing] = useState<number | undefined>(
    undefined
  );
  const [lineHeight, setLineHeight] = useState<number | undefined>(undefined);
  const [marginLeft, setMarginLeft] = useState<number | undefined>(undefined);

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (cardRef.current) {
        setFontSize(Math.floor(0.035 * cardRef.current.clientWidth));
        setLetterSpacing(0.001 * cardRef.current.clientWidth);
        setLineHeight(0.05 * cardRef.current.clientWidth);
        setMarginLeft(0.4 * cardRef.current.clientWidth);
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return (
    <div ref={cardRef} className={styles.card}>
      <div
        style={{
          fontSize: `${fontSize}px`,
          letterSpacing: `${letterSpacing}px`,
          lineHeight: `${lineHeight}px`,
          marginLeft: `${marginLeft}px`,
          width: "100%",
        }}
      >
        <p>At the end of a cold night</p>
        <p>it drops its leaves.</p>
        <p>Like a traitorous hair,</p>
        <p>disappears down the drain.</p>
        <p>Lives its freedom there.</p>
        <p>How so, overnight,</p>
        <p>your feathers are to escape?</p>
        <p>How so, khaki so,</p>
        <p>a soft resting spot you can't locate?</p>
        <p>From somewhere afar, a noise.</p>
        <p>How much time until morning?</p>
        <p>I'm late, not walking, in vain.</p>
        <p>I'm cold,</p>
        <p>I'm not wise.</p>
        <p>Without a pause day and night wane.</p>
        <p>Good morning, fruit of the Gods,</p>
        <p>My situation so astringent!</p>
        <p>Sorry it's unpleasant,</p>
        <p>the surrounding mobs.</p>
      </div>
    </div>
  );
}
